import { use_slice_generation, use_slice_ui } from '@/hooks/store/use_slices';
import { DTO__generation_tool } from '@shared/dto/generation/DTO__generation_tool';
import { HOOK__get_tools_map } from '../../editor/HOOK__get_tools_map';
import { G_LIST_BLOCK_HEADER__generation_tools_with_grid2d_views } from './G_LIST_BLOCK_HEADER__generation_tools_with_grid2d_views';
import { G_LIST_ITEM__generation_tool_and_grid2d_views } from './G_LIST_ITEM__generation_tool_and_grid2d_views';

export function G_SIDEBAR__generation_tools_and_grid2d_views() {
  const { generation_current } = use_slice_generation(['generation_current']);
  const { g_tools__output_type } = use_slice_ui(['g_tools__output_type']);

  let { graph } = generation_current.tool;

  /*
   *
   */
  let memo__tools_map = HOOK__get_tools_map();

  /*
   * METHODS
   */
  /*
   *
   */

  function render_items() {
    let out = [];

    let is_same_output_with_current = g_tools__output_type == graph.meta.output_type;

    /*
     * CURRENT
     */
    if (!is_same_output_with_current) {
      out.push(render_block_title(graph.meta.output_type));

      out.push(<G_LIST_ITEM__generation_tool_and_grid2d_views key={`item_tool_current`} tool={generation_current.tool} />);

      out.push(render_block_title(g_tools__output_type));
    }

    /*
     * ITEMS
     */

    let tools_list = memo__tools_map.values().sort(DTO__generation_tool.sort_by_name);

    for (let tool of tools_list) {
      out.push(<G_LIST_ITEM__generation_tool_and_grid2d_views key={`item_tool_${tool.name}`} tool={tool} />);
    }

    return out;
  }

  function render_block_title(title: string) {
    if (!title) debugger;

    return (
      <div key={`block_title_${title}`} className="px-2 py-0.5 bg-bar text-sm text-bar-foreground">
        {title.replaceAll('_', ' ')}
      </div>
    );
  }

  /*
   *
   */
  if (generation_current.is_stub()) return null;

  return (
    <div className={`w-full flex-1 flex flex-col bg-bar min-w-0 min-h-0`}>
      <G_LIST_BLOCK_HEADER__generation_tools_with_grid2d_views text="Tools and Grid2D Views" />
      {render_items()}
    </div>
  );
}
